import SitePreviewContext from "../../website/components/SitePreviewContext";
import { css } from "@emotion/react";
import { theme } from "@minted/minted-components";
import React, { memo, useContext } from "react";

export type FormFieldWrapperProps = {
  children: React.ReactNode;
  label: string;
  helperText?: string;
};

const styles = {
  title: (isMobile: boolean) => css`
    ${
      isMobile
        ? theme.typeStyles.titleExtraSmallStyles
        : theme.typeStyles.titleSmallStyles
    };
    margin-bottom: ${theme.spacing.base};
  `,
  helperText: css`
    ${theme.typeStyles.bodyExtraSmallStyles};
    margin-bottom: ${theme.spacing.x4};
    margin-top: ${theme.spacing.base};
  `,
};

/**
 * Wrapper component for form fields with consistent label styling.
 * Combines InputLabel with field content for consistent spacing and styling.
 *
 * @example
 * ```tsx
 * <FormFieldWrapper label="Title">
 *   <TextInput ... />
 * </FormFieldWrapper>
 * ```
 */
const FormFieldWrapper = ({
  children,
  label,
  helperText,
}: FormFieldWrapperProps) => {
  const { isMobile } = useContext(SitePreviewContext);

  return (
    <div>
      <div css={styles.title(isMobile)}>{label}</div>
      {children}
      {helperText && <p css={styles.helperText}>{helperText}</p>}
    </div>
  );
};

const MemoizedFormFieldWrapper = memo(FormFieldWrapper);

export { MemoizedFormFieldWrapper as FormFieldWrapper };
